import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AdminComponent } from "./admin/admin.component";

const routes: Routes = [
  {
    path: "",
    component: AdminComponent,
    children: [
      {
        path: "",
        redirectTo: "dashboard/default",
        pathMatch: "full",
      },
      {
        path: "loading-data",
        loadChildren: () =>
          import("./admin/cache/load-data/load-data.module").then(
            (m) => m.LoadDataModule
          ),
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./admin/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: "system",
        loadChildren: () =>
          import("./admin/system/system.module").then((m) => m.SystemModule),
      },
      {
        path: "hardware-templates",
        loadChildren: () =>
          import("./admin/hardware-templates/hardware-templates.module").then(
            (m) => m.HardwareTemplatesModule
          ),
      },
      {
        path: "reception",
        loadChildren: () =>
          import("./admin/reception/reception.module").then(
            (m) => m.ReceptionModule
          ),
      },
      {
        path: "doors-setups",
        loadChildren: () =>
          import("./admin/door-setups/door-setups.module").then(
            (m) => m.DoorSetupsModule
          ),
      },
      {
        path: "products-setups",
        loadChildren: () =>
          import("./admin/products-setups/products-setups.module").then(
            (m) => m.ProductsSetupsModule
          ),
      },
      {
        path: "access-management",
        loadChildren: () =>
          import("./admin/access-management/access-management.module").then(
            (m) => m.AccessManagementModule
          ),
      },
      {
        path: "user-management",
        loadChildren: () =>
          import("./admin/user-management/user-management.module").then(
            (m) => m.UserManagementModule
          ),
      },
      {
        path: "integra-clients",
        loadChildren: () =>
          import(
            "./admin/user-management/integra-clients/integra-clients.module"
          ).then((m) => m.IntegraClientsModule),
      },
      {
        path: "monitoring",
        loadChildren: () =>
          import("./admin/monitoring/monitoring.module").then(
            (m) => m.MonitoringModule
          ),
      },
      {
        path: "communication-settings",
        loadChildren: () =>
          import(
            "./admin/communication-settings/communication-settings.module"
          ).then((m) => m.CommunicationSettingsModule),
      },
      {
        path: "events-log",
        loadChildren: () =>
          import("./admin/events-log/events-log.module").then(
            (m) => m.EventsLogModule
          ),
      },

      {
        path: "house-keeping",
        loadChildren: () =>
          import("./admin/house-keeping/house-keeping.module").then(
            (m) => m.HouseKeepingModule
          ),
      },
      {
        path: "emails",
        loadChildren: () =>
          import("./admin/email-management/email-management.module").then(
            (m) => m.EmailManagementModule
          ),
      },
      {
        path: "reception",
        loadChildren: () =>
          import("./admin/reception/reception.module").then(
            (m) => m.ReceptionModule
          ),
      },
      {
        path: "calender-management",
        loadChildren: () =>
          import("./admin/calender-management/calender-management.module").then(
            (m) => m.CalenderManagementModule
          ),
      },
      {
        path: "skyaccess",
        loadChildren: () =>
          import("./admin/skyaccessconfig/skyaccessconfig.module").then(
            (m) => m.SkyAccessConfigModule
          ),
      },
    ],
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: "**",
    redirectTo: "auth/signin",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
